module.exports = __webpack_public_path__ + "img/Icon_Home.1c94118a.svg";